

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setHeaderName, setSubHeaderName } from '../../../../ReduxStore/Slices/headerSlice';
import { Backdrop, Box, Button, Grid, Typography } from '@mui/material';
import CustomInputLogin from '../../../../Components/CustomInputLogin/CustomInputLogin';
import { Formik, Form } from 'formik';
import CustomExcelUpload from '../../../../Components/CustomExcelUpload/CustomExcelUpload';
import { BackHandSharp, Upload } from '@mui/icons-material';
import { IoIosArrowRoundBack } from "react-icons/io";
import CustomTable from '../../../../Components/Table/CustomTable';
import actions from '../../../../ReduxStore/actions';
import CustomInputForm from '../../../../Components/CustomInputLogin/CustomInputForm';
import { toast, ToastContainer } from 'react-toastify';
import * as Yup from 'yup';
import FullPageLoader from '../../../../Components/FullPageLoader/FullPageLoader';


// const validationSchema = Yup.object().shape({
//     duration: Yup.string()
//         .trim()
//         .required('Year of duration is required.')
//         .matches(
//             /^\d{4}-\d{2}$/,
//             'Duration must be in the format YYYY-YY (e.g., 2014-15).'
//         ),
// });
const validationSchema = Yup.object().shape({
    duration: Yup.string()
        .trim()
        .required('Year of duration is required.')
        .matches(/^\d{4}-\d{2}$/, 'Duration must be in the format YYYY-YY (e.g., 2024-25).')
        .test('valid-duration', 'Second year must be first year + 1', function (value) {
            if (!value) return false;

            const [startYearStr, endYearStr] = value.split('-');
            const startYear = parseInt(startYearStr, 10);
            const endYear = parseInt(endYearStr, 10);

            const expectedEndYear = (startYear + 1) % 100; // only last 2 digits
            return endYear === expectedEndYear;
        }),
});


const YearOfDuration = () => {
    const dispatch = useDispatch();
    const [showExcelUpload, setShowExcelUpload] = useState(false); // State to toggle
    const tableHeadData = ["S.No", "Year of Appraisal", "Actions"];
    const tableData = [
        { DurationId: "3", Duration: "2014-15" },
        { DurationId: "4", Duration: "2014-15" },
        { DurationId: "5", Duration: "2014-15" },
        { DurationId: "6", Duration: "2014-15" },

    ]


    useEffect(() => {
        dispatch(setHeaderName("Master"));
        dispatch(setSubHeaderName("Year of Appraisal"));
    }, [dispatch]);

    const [editData, setEditData] = useState()
    const { updateAppraisalYear } = useSelector((state) => state?.updateAppraisalYear);
    const { createAppraisalYear } = useSelector((state) => state?.createAppraisalYear);
    const { bulkUploadDesignations } = useSelector((state) => state?.bulkUploadDesignations);



    const [loading, setLoading] = useState(false);



    const handleSubmit = async (values, { resetForm }) => {
        console.log(values, "valuesssssss")
        setLoading(true)

        // if (values?.file === null) {
        const data1 = {
            data: {
                appraisal_year: values?.duration
            },
            method: editData?.appraisal_year_id ? "put" : "post",
            apiName: editData?.appraisal_year_id ? `updateAppraisalYear/${editData?.appraisal_year_id}` : "createAppraisalYear"
        };
        const responseData = await dispatch(editData?.appraisal_year_id ? actions.UPDATEAPPRAISALYEAR(data1) : actions.CREATEAPPRAISALYEAR(data1));
        console.log(responseData, "responseData")
        if (responseData?.payload?.message === "AppraisalYear created and folder initialized.") {
            setLoading(false)
            toast.success("Appraisal Year created successfully.")
            resetForm()
        } else if (responseData?.payload?.message === "Appraisal year updated.") {
            setLoading(false)
            toast.success("Appraisal year upadated successfully.")
            setEditData()
        }
        else {
            setLoading(false)
            toast.error(responseData?.payload?.message)
        }
        // }



    }


    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")


    const { getAllAppraisalYears } = useSelector((state) => state?.getAllAppraisalYears);
    console.log(getAllAppraisalYears, "getAllAppraisalYears")

    useEffect(() => {
        const fetchData = async () => {

            const data1 = {
                data: {},
                method: "get",
                apiName: "getAllAppraisalYears"
            };
            const responseData = dispatch(actions.GETALLAPPRAISALYEAR(data1));
            console.log(responseData, "responseData")


        }
        fetchData()

    }, [updateAppraisalYear, createAppraisalYear, bulkUploadDesignations])

    useEffect(() => {

        const tempArr = [];

        getAllAppraisalYears?.data?.map((data, index) => {
            return tempArr.push({
                // id: data?.internship_id,
                id: data?.appraisal_year_id,
                appraisal_year: data?.appraisal_year
            });
        });
        setRowTableData(tempArr);




    }, [getAllAppraisalYears])




    const { getAppraisalYearById } = useSelector((state) => state?.getAppraisalYearById);


    const handleTableEdit = async (id) => {
        setShowExcelUpload(false)
        setLoading(true)
        console.log(id, "idgretoriut")
        const data1 = {
            data: {},
            method: "get",
            apiName: `getAppraisalYearById/${id}`
        };
        const responseData = await dispatch(actions.GETAPPRAISALYEARBYID(data1));
        console.log(responseData, "getAppraisalYearById")
        if (responseData?.payload?.message === "All AppraisalYear fetched successfully.") {
            setLoading(false)
            setEditData(responseData?.payload?.data)
        }


    }



    return (
        <Box>
            {loading && <FullPageLoader />}
            <Box
                sx={{
                    background: "white",
                    p: 3
                }}
            >
                <Box
                    sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                    <Typography variant='subtitle2' sx={{ color: "black", fontSize: "18px" }}>
                        Add Year of Appraisal
                    </Typography>

                </Box>

                <Formik
                    enableReinitialize
                    initialValues={{
                        duration: editData?.appraisal_year || '',
                    }}
                    validationSchema={validationSchema}

                    onSubmit={handleSubmit}
                >
                    {({ errors, touched, handleChange, values, setFieldValue, resetForm }) => (
                        <Form>
                            <Grid container spacing={2} mt={2}>
                                <Grid item size={{ xs: 12, md: 6 }}>

                                    <CustomInputForm
                                        name="duration"
                                        label="Year of Appraisal"
                                        custPlaceholder="Ex.2014-15"
                                    />

                                </Grid>

                                {/* {!showExcelUpload && ( */}
                                <Grid item size={{ xs: 12 }} sx={{ mt: 3 }}>
                                    <Button
                                        type="submit"
                                        variant='contained'
                                        sx={{
                                            background: "var(--main-color)",
                                            textTransform: "none"
                                        }}
                                    >
                                        {editData?.appraisal_year_id ? "Update" : "Submit"}

                                    </Button>
                                </Grid>
                                {/* )} */}
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </Box>
            <Box
                sx={{
                    background: "white",
                    p: 3,
                    mt: 6
                }}
            >
                <CustomTable
                    tableHeadData={tableHeadData}
                    tableData={rowTableData}
                    title="Year of Appraisal List"
                    tableEdit={true}
                    tableActions={true}
                    tableSearch={true}
                    handleTableEdit={handleTableEdit}

                />
            </Box>
            <ToastContainer position="top-right" autoClose={1500} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="dark" />

        </Box>
    );
};

export default YearOfDuration;
